"use strict";import{css as t}from"@spectrum-web-components/base";const e=t`
    :host{contain:strict;pointer-events:none;display:block;position:relative}::slotted(*){pointer-events:all}
`;export default e;
//# sourceMappingURL=grid.css.js.map
